import "./product-option";

const INVALID_CLASS = "product-form__option-input--invalid";

class ProductFormSelectors extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (e) => this.handleChange(e.target));

    const currentVariant = this.getAttribute("current-variant");

    if (currentVariant) {
      const data = window.scrapeSectionData(this);
      const variant = data.variants.find(
        (variant) => variant.id.toString() === currentVariant,
      );

      if (variant) {
        variant.options.forEach((optionValue, i) => {
          const optionInput = this.querySelector(
            `[data-option-index="${i}"][data-option-value="${optionValue}"]`,
          );

          if (optionInput) {
            optionInput.checked = true;
          }
        });
      }
    }
  }

  disconnectedCallback() {}

  handleChange(target) {
    this.data = window.scrapeSectionData(this);

    target.classList.remove(INVALID_CLASS);

    const selectedOptionValueId = parseInt(target.value, 10);
    const selectedOptionIndex = parseInt(target.dataset.optionIndex, 10);

    this.querySelectorAll("[data-option-value]").forEach((optionValue) => {
      const optionIndex = parseInt(optionValue.dataset.optionIndex);

      if (optionIndex === selectedOptionIndex) return;

      const optionValueId = parseInt(optionValue.value, 10);

      const valid = this.data.optionsByVariant.some((variant) => {
        const matchesSelectedOption =
          variant.variantOptions[selectedOptionIndex].id ===
          selectedOptionValueId;
        const matchesOptionValue =
          variant.variantOptions[optionIndex].id === optionValueId;

        return matchesSelectedOption && matchesOptionValue;
      });

      optionValue.classList.toggle(INVALID_CLASS, !valid);
    });

    const form = this.closest("form");

    const selectedOptionValueIds = new Array(this.data.productOptionsCount)
      .fill(null)
      .map((_, i) => parseInt(form[`option-${i + 1}`]?.value, 10));

    const matchingVariant = this.data.optionsByVariant.find((variant) =>
      selectedOptionValueIds.every(
        (selectedOptionValueId, i) =>
          selectedOptionValueId === variant.variantOptions[i].id,
      ),
    );

    let variant = null;

    if (matchingVariant) {
      variant = this.data.variants.find(
        (variant) => variant.id === matchingVariant.variantId,
      );
    }

    this.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: {
          source: this,
          variant,
          variantUrl: matchingVariant?.variantUrl || null,
        },
      }),
    );
  }
}

if (!customElements.get("product-form-selectors")) {
  customElements.define("product-form-selectors", ProductFormSelectors);
}
